module.exports = __webpack_public_path__ + "img/fondo_texto_educacion.a3628ec6.png";